// steps
import personalLoanSteps from '@/form/steps/initial.js';
// products
import debtConsolidationSteps from '@/form/products/debt_consolidation.js';
import carLoanSteps from '@/form/products/car_loan.js';
import lifeInsuranceSteps from '@/form/products/life_insurance.js';
import helocSteps from '@/form/products/heloc.js';
import powersportsSteps from '@/form/products/powersports.js';
import businessLoanSteps from '@/form/products/business_loan.js';
// quiz
import helocQuizSteps from '@/form/quiz/heloc.js';

const STEPS_PER_PRODUCT = {
    debt_consolidation: debtConsolidationSteps,
    personal_loan: personalLoanSteps,
    car_loan: carLoanSteps,
    life_insurance: lifeInsuranceSteps,
    heloc: helocSteps,
    heloc_quiz: helocQuizSteps,
    powersports: powersportsSteps,
    business_loan: businessLoanSteps,
}

export function getSteps(product) {
    return STEPS_PER_PRODUCT[product] ?? personalLoanSteps;
}
